import { render, staticRenderFns } from "./records.vue?vue&type=template&id=aedb5a12&scoped=true&"
import script from "./records.vue?vue&type=script&lang=js&"
export * from "./records.vue?vue&type=script&lang=js&"
import style0 from "./records.vue?vue&type=style&index=0&id=aedb5a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedb5a12",
  null
  
)

export default component.exports